export default "__VITE_PUBLIC_ASSET__69708855__"